// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.form-content {
  padding: 16px;
}
.form-content .group-title-section {
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
}
.form-content .group-title-section .create-homeroom-label {
  color: #444343;
  display: flex;
  gap: 4px;
  flex-direction: column;
  font-weight: 500;
}
.form-content .group-title-section .create-homeroom-label .create-homeroom-input {
  border-radius: 5px;
  border: 1px solid #808080;
  font-size: 14px;
  height: 34px;
  padding: 2px 4px;
  width: 360px;
}
.form-content .group-form-buttons {
  display: flex;
  height: 34px;
  justify-content: flex-end;
  margin: 24px -10px 24px 0px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/HomeroomGroups.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,aAAA;AAUJ;AARI;EACI,qBAAA;EACA,aAAA;EACA,8BAAA;AAUR;AARQ;EACI,cDoBH;ECnBG,aAAA;EACA,QAAA;EACA,sBAAA;EACA,gBAAA;AAUZ;AATY;EACI,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AAWhB;AANI;EACI,aAAA;EACA,YAAA;EACA,yBAAA;EACA,2BAAA;AAQR","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.form-content {\n    padding: 16px;\n\n    .group-title-section {\n        align-items: flex-end;\n        display: flex;\n        justify-content: space-between;\n\n        .create-homeroom-label {\n            color: $grey4a;\n            display: flex;\n            gap: 4px;\n            flex-direction: column;\n            font-weight: 500;\n            .create-homeroom-input {\n                border-radius: 5px;\n                border: 1px solid $grey3;\n                font-size: 14px;\n                height: 34px;\n                padding: 2px 4px;\n                width: 360px;\n            }\n        }\n    }\n\n    .group-form-buttons {\n        display: flex;\n        height: 34px;\n        justify-content: flex-end;\n        margin: 24px -10px 24px 0px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
